import * as React from 'react';
import { styled } from '@mui/system';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { InputLabel } from "@mui/material";

const StyledTextareaElement = styled(TextareaAutosize)`
  width: 100%;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3A415A;
  background: #fff;
  border: 1px solid #939599;
  border-radius: 5px;
  padding: 9px 15px;

  &:focus {
    outline: 1px solid #000;
  }

  &.error {
    border: 1px solid #d90208;
  }
`;

export default function CustomTextarea(props) {

  return (
    <>
      {props.label &&
      <InputLabel sx={{marginBottom: '8px', color: '#3A415A'}}>{props.label}{props.required && <> *</>}</InputLabel>
      }
      <StyledTextareaElement
        {...props}
        placeholder={props.placeholder}
      />
    </>
  )
}
